var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apply-btn",on:{"click":_vm.applyFn}},[_vm._v("我要报名")])
}
var staticRenderFns = []

export { render, staticRenderFns }